export const version = '1.1.0';
export const buildTime = 'Tue Jan 27 2026 09:39:53 GMT+0100 (Central European Standard Time)';
export const sourceUrl = 'https://github.com/CentreForDigitalHumanities/gen-ai-reflection/tree/50c28fcd8f8b23495c98c0c1c53ffa918d6171d2';
